module.exports = __webpack_public_path__ + "media/images/payment-mastercard-1ed698ad002c4d5f7b5971261b7ebc9d.png";